import { BAR_IMAGE_SOURCE_STYLE, BAR_SLIDER_VALUE_PROPERTIES, MAIN_STYLE, MAIN_STYLE_GROUPS, PRESS_EVENTS, SIGNED_PADDING_SIDES, LVGL_STYLE_INT_MIN, LVGL_STYLE_INT_MAX } from '../shared.js'
import { OPENHASP_CONTROL_TYPE, OPENHASP_CONTROL_TYPE_VALUES } from '../../../controlTypes.js'
export const bar = {

    displayName: 'Bar',

    // LVGL-style parts — label/exportSuffix/order are the source of truth for
    // the Property Editor and for legacy JSONL wire keys (see v2/shared.js
    // part metadata doc and v2/wireFormat.js toWireKey).
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
                ...BAR_IMAGE_SOURCE_STYLE,
                // LVGL Bar/Slider read BG pad_* directly when calculating the
                // indicator area. These are signed lv_style_int_t values;
                // `padding` remains the editor/export shorthand for all sides.
                padding: { type: 'int', min: LVGL_STYLE_INT_MIN, max: LVGL_STYLE_INT_MAX, exportSpecial: true },
                ...SIGNED_PADDING_SIDES,
                keep_circle: { type: 'bool', internal: true },
            },
        },
        indicator: {
            label: 'Indicator',
            exportSuffix: '10',
            order: 1,
            properties: {
                bg_color:     { type: 'color' },
                ...BAR_IMAGE_SOURCE_STYLE,
                radius:       { type: 'int', min: 0, max: 999 },
                // Restored — HaspBar.js's indicator rect still actively
                // strokes with these (via this.style('indicator')); they were
                // commented out here previously, leaving the widget's own
                // rendering disconnected from the Property Editor and from
                // schema.defaults.styles.indicator.border_color (which the
                // schema validator flagged as orphaned).
                border_width: { type: 'int', min: 0 },
                border_color: { type: 'color' },
                keep_circle:  { type: 'bool', internal: true },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        val:         { type: 'int' }, min: { type: 'int' }, max: { type: 'int' },
        ...BAR_SLIDER_VALUE_PROPERTIES,
        start_value: { type: 'int', visibleWhen: { property: 'type', equals: OPENHASP_CONTROL_TYPE.RANGE } },
        type:        { type: 'enum', values: OPENHASP_CONTROL_TYPE_VALUES, label: 'Type' },
        entityid:    { type: 'string', internal: true },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 20, min_width: 5, min_height: 5,
            enabled: true,
            hidden: false,
            min: 0, max: 100, val: 0, step: 0, start_value: 0, type: 0,
        },
        styles: {
            // bar_init() is entirely commented out in firmware; real defaults come from the
            // shared "pretty" (main/bg)/"pretty_color" (indicator) styles applied via
            // theme_apply's LV_THEME_BAR case (lv_theme_hasp.c:1133-1141): radius = LV_DPI/15
            // (~10 at reference DPI, lv_theme_hasp.c:251/296), bg_opa = LV_OPA_COVER
            // (lv_theme_hasp.c:256/301 — main only; the schema's `indicator` part has no
            // bg_opa property to override), border_color = the BORDER_COLOR macro
            // (lv_theme_hasp.c:82: light-theme #404040 / dark-theme #b0b0b0 — this schema has
            // no light/dark-conditional default mechanism, only the bundled theme files do, so
            // the light value is used here as a neutral placeholder, same convention as
            // dropdown's scrollbar.bg_color). Previously hardcoded literal 'black' with no
            // radius/bg_opa default at all.
            main:      { border_color: '#404040', radius: 10, bg_opa: 255 },
            indicator: { border_color: '#404040', border_width: 0, radius: 10 },
        },
    },
    states: ['pressed', 'disabled'],
    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu'],
    runtimeCapabilities: ['has_data'],

    // Bar keeps the generic press lifecycle. Range values are data properties,
    // not a Slider-style changed event source.
    events: PRESS_EVENTS,

    automation: {
        runtimeVariables: [],
        actionDomains: ['homeassistant', 'light', 'switch', 'cover', 'climate', 'automation', 'openhasp', 'esphome'],
    },

    convertTo: ['slider'],

    bindings: {
        properties: { val: {}, min: {}, max: {}, start_value: {}, border_color: {}, indicator: { bg_color: {} } },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'automation', 'climate', 'light', 'switch', 'cover', 'esphome'] },
        events: {},
    },
}
